"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var isValidBoolean = function isValidBoolean(x) {
  return typeof x === 'boolean' && x;
};

var isValidNumber = function isValidNumber(x) {
  return typeof x === 'number' && x > 0;
};

var Col = function Col(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      xlarge = _ref.xlarge,
      offset = _ref.offset;
  var classes = (0, _classnames.default)('ui-col', className, (_classNames = {
    'ui-col-small--collapse': small === 0,
    'ui-col-medium--collapse': medium === 0,
    'ui-col-large--collapse': large === 0,
    'ui-col-xlarge--collapse': xlarge === 0,
    'ui-col-small': isValidBoolean(small),
    'ui-col-medium': isValidBoolean(medium),
    'ui-col-large': isValidBoolean(large),
    'ui-col-xlarge': isValidBoolean(xlarge)
  }, (0, _defineProperty2.default)(_classNames, "ui-col-small-".concat(small), isValidNumber(small)), (0, _defineProperty2.default)(_classNames, "ui-col-medium-".concat(medium), isValidNumber(medium)), (0, _defineProperty2.default)(_classNames, "ui-col-large-".concat(large), isValidNumber(large)), (0, _defineProperty2.default)(_classNames, "ui-col-xlarge-".concat(xlarge), isValidNumber(xlarge)), (0, _defineProperty2.default)(_classNames, "ui-col--offset-".concat(offset), isValidNumber(offset)), _classNames));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, children);
};

Col.defaultProps = {
  className: ''
};
Col.propTypes = {
  /** Child content rendered inside Col. */
  children: _propTypes.default.node,

  /** Custom class name added to Col. */
  className: _propTypes.default.string,

  /** Number or boolean to specify how much of the grid to use for the small breakpoint. */
  small: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),

  /** Number or boolean to specify how much of the grid to use for the medium breakpoint. */
  medium: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),

  /** Number or boolean to specify how much of the grid to use for the large breakpoint. */
  large: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),

  /** Number or boolean to specify how much of the grid to use for the xlarge breakpoint. */
  xlarge: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),

  /** Number to specify how many empty columns to skip before starting this one. */
  offset: _propTypes.default.number
};
var _default = Col;
exports.default = _default;
//# sourceMappingURL=Col.js.map